var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import background from '@cta-portal/webapp-common/src/assets/images/backgrounds/background-texture.png';
import React from 'react';
import Div100vh from 'react-div-100vh';
import styled from 'styled-components';
import Footer from './footer';
import Head from './head';
import Header from './header';
import Main from './main';
export default function Layout(_a) {
    var children = _a.children;
    return (_jsxs(Container, { children: [_jsx(Head, {}), _jsx(Header, {}), _jsx(Main, { children: children }), _jsx(Footer, {})] }));
}
var Container = styled(Div100vh)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background: url('", "');\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 100vw;\n"], ["\n  align-items: center;\n  background: url('", "');\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 100vw;\n"])), background);
var templateObject_1;
